module.exports = {
  message: {
    home_pro_title: '产品认证',
    home_verify_title: '产品验证：',
    home_button_scan: '使用您的摄像头进行扫描',
    home_button_file: '选择AB码图片',
    home_button_app: '下载蒸汽时光APP',
    home_qr_text: '防伪码在哪儿？',
    home_find_title: '在产品盒上找到A码，如下图所示.',
    home_use_title: '使用您的摄像头扫描A码或从您的相册中选择A码图片.',
    home_fake_title: '防伪码验证操作教程',
    home_modal_hint: '为了更方便绑定您的设备，请允许我们获取您的摄像头使用权限',
    home_modal_OK: '好的',
    home_model_not_scanner_code_a: '没有扫描到A码，请确认图片是否清晰.',
    A_activate_hint: '产品:',
    A_activate_cur: '当前产品的状态',
    A_activate_act: '已激活',
    A_activate_act_hint: '激活 ',
    A_activate_bind_email: '激活的邮箱地址: {email}',
    A_activate_bind_device: '激活设备的 ID: {device}',
    A_activate_purchase: '如果设备非本人激活，请不要购买.',
    A_activate_report: '举报伪劣商品',
    A_activate_device: '设备 ',
    A_activate_email: '电子邮箱 ',
    A_fake_counterfeits: '举报伪劣商家',
    A_nonactivate_prohint: '产品:',
    A_nonactivate_SNhint: '序列号:',
    A_nonactivate_cur: '当前设备的状态',
    A_nonactivate_act: '未激活',
    A_nonactivate_time: '该产品A码已被查询过 {count} 次',
    A_nonactivate_time_1: '次数',
    A_nonactivate_btn: '激活设备',
    A_nonactivate_scan: '扫描B码',
    B_bind_prohint: '该产品为正品',
    B_bind_email: '请输入您的邮箱用于绑定产品',
    B_bind_addr: '请填写正确的邮箱以确保该产品是由本人激活.',
    B_bind_btn: '绑定产品',
    B_fake_fail: '绑定失败!',
    B_fake_scan: '请提供正确的B码',
    home_model_not_scanner_code_b: '没有扫描到B码，请确认图片是否清晰.',
    B_fake_btn_scan: '重新扫描B码',
    inform_input_name: '姓名（必需）',
    inform_input_email: '邮箱（必需）',
    inform_input_number: '电话号码（必需）',
    inform_input_store_name: '店铺名称或者网址',
    inform_input_store_address: '店铺地址',
    inform_input_feedback: '反馈内容(必需)',
    inform_input_submit: '提交',
    A_query_result: '查询结果',
    success: '成功',
    success_content: {
      'bind': '绑定成功',
      'activate': '激活成功'
    },
    error: '失败',
    copy_a_success: 'A码复制成功',
    copy_a_fail: 'A码复制失败',
    home_title:'开始你的IVPS之旅',
    tipText:'将二维码对准方框进行扫描',
    Back:'返回',
    Copy_security_code:'复制防伪码',
    switch_language:'切换语言',
    a_black_text:'该产品确认为假货，购买此产品可能会引发安全事故，严重危害您和身边人的生命健康，请您不要购买。',
  },
  "Warning": {
    "WARNING": "WARNING",
    "slogan": "This product is intended to be used with e-liquid products containing nicotine. Nicotine is an addictive chemical.",
    "safety": "Important Safety Information and Warnings",
    "age": "You have to make sure that your age is 21 or older, then you can download this application. Otherwise, please leave and close this page immediately!",
    "UNDER": "UNDER"
},
}